import React, { useRef, useState, useEffect } from 'react';
import { Tooltip } from 'antd';

interface EllipsisTooltipCellProps {
    text: string;
    className?: string;
}

const EllipsisTooltipCell: React.FC<EllipsisTooltipCellProps> = ({ text, className }) => {
    const divRef = useRef<HTMLDivElement>(null);
    const [isOverflowed, setIsOverflowed] = useState(false);
    const [showTooltip, setShowTooltip] = useState(false);

    useEffect(() => {
        const checkOverflow = () => {
            if (divRef.current) {
                setIsOverflowed(divRef.current.scrollWidth > divRef.current.clientWidth);
            }
        };

        checkOverflow();

        window.addEventListener('resize', checkOverflow);
        return () => {
            window.removeEventListener('resize', checkOverflow);
        };
    }, [text]);

    return (
        <Tooltip title={text} overlayClassName="custom_tooltip" visible={showTooltip}>
            <div
                ref={divRef}
                className={className}
                style={{
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    cursor: 'pointer'
                }}
                onMouseEnter={() => {
                    if (divRef.current) {
                        setShowTooltip(divRef.current.scrollWidth > divRef.current.clientWidth);
                    }
                }}
                onMouseLeave={() => setShowTooltip(false)}
            >
                {text}
            </div>
        </Tooltip>
    );
};

export default EllipsisTooltipCell;
